export default class DashboardComponentDto {

    Id: number;
    Name: string;
    Type: number;

    constructor(id: number, name: string, type: number) {
        this.Id = id;
        this.Name = name;
        this.Type = type;
    }
}
